<template>
  <div class="container" v-loading="isloading">
    <!-- <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="container mb17 mt6"
    >
      <el-breadcrumb-item :to="{ path: '/' }">搜索</el-breadcrumb-item>
      <el-breadcrumb-item>搜索结果</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="flex between BGwhite search-box mt20">
      <ul class="my-tabs">
        <li class="my-tabs-item" :class="{ active: navIndex1 == item.value }" @click="navIndex1 = item.value"
          v-for="item in navArr1" :key="item.value">
          {{ item.label }}
        </li>
      </ul>
      <div v-if="getListData.Title" class="total">
        共有{{ total }}条包含“<span>{{ getListData.Title }}</span>”的内容
      </div>
    </div>
    <div class="mb50">
      <div v-if="list[0] && navIndex1 == 1" class="my-table-1">
        <a @click="goto(`/courseDetail?CourseID=${item.CourseID}`)" class="table-item" v-for="(item, index) in list"
          :key="index">
          <div class="img">
            <img :src="item.ImgPath" @error="imgError" alt="" />
          </div>
          <div class="content">
            {{ item.CourseName }}
          </div>
          <div class="flex mt20">
            <div class="type"># {{ item.ClassifyName }}</div>
            <div class="red">
              ¥ <span class="amout">{{ item.Price }}</span>
            </div>
          </div>
          <div class="flex mt10">
            <div class="rate">
              <span class="mr5">{{ parseFloat(item.StarNum).toFixed(1) }}</span>
              <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
              </el-rate>
            </div>
            <div class="user">
              <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
            </div>
          </div>
        </a>
      </div>
      <div v-if="list[0] && navIndex1 == 2" class="my-table-2">
        <a @click="goto(`/materialDetail?MaterialID=${item.MaterialID}`)" class="table-item"
          v-for="(item, index) in list" :key="index">
          <div class="table-item-top">
            <div class="img">
              <img v-if="item.FileExt == '.docx' || item.FileExt == '.doc'" src="@/assets/img/home/29.png" alt="" />
              <img v-if="item.FileExt == '.zip'" src="@/assets/img/home/30.png" alt="" />
              <img v-if="item.FileExt == '.ppt'" src="@/assets/img/home/31.png" alt="" />
              <img v-if="item.FileExt == '.rar'" src="@/assets/img/home/32.png" alt="" />
              <img v-if="item.FileExt == '.txt'" src="@/assets/img/home/33.png" alt="" />
              <img v-if="item.FileExt == '.7z'" src="@/assets/img/home/34.png" alt="" />
              <img v-if="item.FileExt == '.pdf'" src="@/assets/img/home/35.png" alt="" />
            </div>
            <div class="right">
              <div class="name">{{ item.MaterialName }}</div>
              <div class="value">
                <span>{{ item.MaterialExt }}</span>
                <span>{{ item.FileSizeTxt }}</span>
              </div>
            </div>
          </div>

          <div class="content">
            {{ item.CourseName }}
          </div>
          <div class="flex mt20">
            <div class="type"># {{ item.ClassifyName }}</div>
            <div class="red">
              ¥ <span class="amout">{{ item.Price }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="rate mt10">
              <span class="mr5">{{ item.StarNum }}</span>
              <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
              </el-rate>
            </div>
            <div class="user">
              <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
            </div>
          </div>
        </a>
      </div>
      <div v-if="list[0] && navIndex1 == 3" class="my-table-3">
        <a @click="goto(`/qbankDetail?ExerciseID=${item.ExerciseID}`)" class="table-item" v-for="(item, index) in list"
          :key="index">
          <div class="table-item-top">
            <div class="img">
              <img src="@/assets/img/home/59.png" alt="" />
            </div>
            <div class="right">
              <div class="name">{{ item.ExerciseName }}</div>
              <div class="value">
                <span>题量：{{ item.TotalNum }}</span>
              </div>
            </div>
          </div>

          <div class="content">
            {{ item.CourseName }}
          </div>
          <div class="flex mt20">
            <div class="type"># {{ item.ClassifyName }}</div>
            <div class="red">
              ¥ <span class="amout">{{ item.Price }}</span>
            </div>
          </div>
          <div class="flex">
            <div class="rate mt10">
              <span class="mr5">{{ item.StarNum }}</span>
              <el-rate v-model="item.StarNum" disabled text-color="#ff9900">
              </el-rate>
            </div>
            <div class="user">
              <img src="@/assets/img/home/4.png" alt="" />{{ item.StudyView }}
            </div>
          </div>
        </a>
      </div>
      <div v-if="list[0] && navIndex1 == 4" class="my-table-4">
        <a @click="goto(`/apipcEnrollDetail?SubjectID=${item.SubjectID}`)" class="table-item"
          v-for="(item, index) in list" :key="index">
          <div class="table-item-top">
            <div class="img">
              <img :src="item.ImgPath" alt="" @error="imgError" />
            </div>
          </div>
          <div class="content">{{ item.Title }}</div>
          <div class="table-item-bottom">
            <p class="ClassifyName">#{{ item.ClassifyName }}</p>
            <p class="PropValue">
              报名起止日期：<span class="EnrollTime">{{
                item.EnrollTime
              }}</span>
            </p>
          </div>
        </a>
      </div>
      <div v-if="list[0] && navIndex1 == 5" class="my-table-5">
        <a @click="goto(`/teacherDetail?TeacherID=${item.TeacherID}`)" class="table-item" v-for="(item, index) in list"
          :key="index">
          <div class="table-item-top">
            <div class="img">
              <img :src="item.Avatar" alt="" @error="imgError" />
            </div>
          </div>

          <div class="table-item-bottom">
            <p class="TeacherName">{{ item.TeacherName }}</p>
            <p class="PropValue">{{ item.PropValue }}</p>
          </div>
        </a>
      </div>
      <el-empty description="暂无内容" :image="empty1" v-if="!list[0]" />
      <my-pagination :total="total" :pageSize="getListData.limit" v-model="getListData.page"></my-pagination>
    </div>
  </div>
</template>

<script>
import myPagination from "@/components/myPagination.vue";
import {
  Course_GetList,
  Material_GetList,
  Exercise_GetList,
  Enroll_GetList,
  Teacher_GetList,
} from "@/api/search";
import Bus from "@/util/bus";
export default {
  components: { myPagination },
  name: "search",
  data() {
    return {
      navIndex: null,
      navArr1: [
        {
          label: "课程中心",
          value: 1,
        },
        {
          label: "资料下载",
          value: 2,
        },
        {
          label: "题库中心",
          value: 3,
        },
        {
          label: "报名通知",
          value: 4,
        },
        {
          label: "师资专家",
          value: 5,
        },
      ],
      navIndex1: 1,
      isloading: false,
      list: [],
      total: 0,
      getListData: {
        Title: null,
        PageIndex: 1,
        PageSize: 15,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    goto(path) {
      this.$router.push({
        path: path,
      });
    },
    handlerError(e) {
      console.log('handlerError');
    },
    getList() {
      this.isloading = true;
      const data = this.getListData;
      let fcn = "";
      switch (this.navIndex1) {
        case 0:
        case 1:
          fcn = Course_GetList;
          break;
        case 2:
          fcn = Material_GetList;
          break;
        case 3:
          fcn = Exercise_GetList;
          break;
        case 4:
          fcn = Enroll_GetList;
          break;
        case 5:
          fcn = Teacher_GetList;
          break;
      }
      fcn(data).then(({ data, count }) => {
        this.total = count;
        this.list = data;
        this.isloading = false;
        Bus.$emit("searchSuccess", true);
      });
    },
    init() {
      this.getListData.Title = this.$route.query.search || null;
      this.navIndex1 = parseInt(this.$route.query.type);
      if (this.getListData.PageIndex === 1) {
        this.getList();
      } else {
        this.getListData.PageIndex = 1;
      }
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
    navIndex1() {
      if (this.getListData.PageIndex === 1) {
        this.getList();
      }
      this.getListData.PageIndex = 1;
    },
    "$route.query": {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  height: 80px;
  background: #ffffff;
  border-radius: 10px;

  .my-tabs {
    &::before {
      display: none;
    }

    .my-tabs-item {
      width: 131px;
      height: 49px;
      text-align: center;
      line-height: 49px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #cccccc;

      &::before {
        display: none;
      }

      &.active {
        color: #1d79ff;
        border: 1px solid #1d79ff;
      }

      &:hover {
        color: #1d79ff;
        border: 1px solid #1d79ff;
      }
    }
  }

  .total {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    padding-right: 20px;

    span {
      color: #1d79ff;
    }
  }
}

.my-table-1 {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 420px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      height: 55px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .img {
      width: 308px;
      height: 231px;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .type {
        font-size: 16px;
        color: #999999;
      }

      .amout {
        font-size: 24px;
        font-weight: bold;
      }

      .red {
        font-size: 16px;
        color: #e12a14;
        font-weight: bold;

      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;

        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }

      .rate {
        display: flex;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}

.my-table-2 {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    height: 194px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .table-item-top {
      display: flex;
      align-items: center;
      gap: 20px;

      .img {
        width: 42px;
        height: 43px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        .name {
          font-size: 20px;
          color: #333333;
        }

        .value {
          display: flex;
          gap: 30px;
          font-size: 16px;
          color: #999999;
        }
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .type {
        font-size: 16px;
        color: #999999;
      }

      .amout {
        font-size: 24px;
        font-weight: bold;
      }

      .red {
        font-size: 16px;
        color: #e12a14;
        font-weight: bold;

      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;

        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }

      .rate {
        display: flex;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}

.my-table-3 {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 194px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .table-item-top {
      display: flex;
      // align-items: center;
      gap: 20px;

      .img {
        width: 42px;
        height: 43px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .right {
        .name {
          font-size: 20px;
          min-height: 60px;
          color: #333333;
        }

        .value {
          display: flex;
          gap: 30px;
          font-size: 16px;
          color: #999999;
        }
      }
    }

    .flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .type {
        font-size: 16px;
        color: #999999;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        flex: 1;
        margin-right: 5px;
      }

      .amout {
        font-size: 24px;
        font-weight: bold;
      }

      .red {
        font-size: 16px;
        color: #e12a14;
        font-weight: bold;

      }

      .user {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #666666;

        img {
          width: 12px;
          height: 17px;
          margin-right: 9px;
        }
      }

      .rate {
        display: flex;
        font-weight: bold;
        font-size: 20px;
        color: #e12a14;
      }
    }
  }
}

.my-table-4 {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 410px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .table-item-top {
      .img {
        width: 308px;
        height: 231px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }
    }

    .content {
      margin-top: 15px;
      font-size: 20px;
      color: #333333;
      display: -webkit-box;
      overflow: hidden;
      /* 超出的文本隐藏 */
      text-overflow: ellipsis;
      /* 溢出用省略号显示 */
      -webkit-box-orient: vertical;
      /* 垂直排列子元素 */
      -webkit-line-clamp: 2;
      /* 显示的行数 */
    }

    .table-item-bottom {
      margin-top: 20px;

      .ClassifyName {
        font-size: 16px;
        color: #999999;
        margin-top: 10px;
      }

      .PropValue {
        margin-top: 5px;
        font-size: 16px;
        color: #999999;

        .EnrollTime {
          font-weight: bold;
          font-size: 16px;
          color: #1d79ff;
        }
      }
    }
  }
}

.my-table-5 {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 480px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;

    &:hover {
      transform: scale(1.01);
    }

    .table-item-top {
      .img {
        width: 308px;
        height: 379px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }
    }

    .table-item-bottom {
      text-align: center;

      .TeacherName {
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        margin-top: 10px;
      }

      .PropValue {
        margin-top: 5px;
        font-weight: 400;
        font-size: 16px;
        color: #999999;
      }
    }
  }
}
</style>
